import { RoundModel } from "@/models/RoundModels";
import { BaseRepo } from "./base/BaseRepo";
import { createRoundMigrationManager } from "@/utils/migrations";



// src/repos/RoundRepo.ts
/**
 * Repository for models in the rounds collection
 */
export class RoundsRepo extends BaseRepo<RoundModel> {
    protected collectionName = 'rounds';
    protected cacheKeyPrefix = 'round_';

    constructor() {
        super();
        this.setupMigrations(createRoundMigrationManager());
    }
}